import { Dispatch, FC, SetStateAction, useEffect } from "react";
import SearchTable from "../../../components/template/Search/SearchTable";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import ModalOccurrenceAlertSan from "../component/ModalOccurrenceAlertSan";
import { FilterConfig } from "../../../types/Components/Table/FilterConfig";
import { Dayjs } from "dayjs";

interface OccurrenceAlertSanProps {
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  paginationConfig: PaginationConfig;
  setIdItem: Dispatch<SetStateAction<number>>;
  tableConfig: TableConfig;
  modalConfig: ModalConfig;
  reset: any;
  filterConfig: FilterConfig;
  setDates: ((date: Dayjs | null) => void)[];
  control: any;
}

const OccurrenceAlertSan: FC<OccurrenceAlertSanProps> = ({
  setIsSearching,
  paginationConfig,
  setIdItem,
  tableConfig,
  modalConfig,
  reset,
  filterConfig,
  setDates,
  control,
}) => {
  useEffect(() => {
    if (!modalConfig.isOpen) {
      reset();
      setIdItem(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalConfig.isOpen, reset]);

  return (
    <SearchTable
      showModal
      searchTableName=""
      headingFontSize="2xl"
      tableConfig={tableConfig}
      filterConfig={filterConfig}
      paginationConfig={paginationConfig}
      setIsSearching={setIsSearching}
      setDates={setDates}
    >
      <ModalOccurrenceAlertSan control={control} modalConfig={modalConfig} />
    </SearchTable>
  );
};

export default OccurrenceAlertSan;
